<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { AuthBrandLogo, AuthBrandPanel } from '@/features/auth'

const route = useRoute()
const isStandalone = computed(() => route.meta.authSurface === 'standalone')
const showLogo = computed(() => !isStandalone.value && route.meta.authLogo !== false)
</script>

<template>
  <main
    class="auth-layout min-h-dvh bg-surface"
    :class="[
      isStandalone
        ? 'auth-layout--standalone block'
        : 'grid grid-cols-[minmax(28rem,1fr)_minmax(28rem,1fr)] max-lg:grid-cols-[minmax(0,1fr)]',
    ]"
  >
    <section
      class="auth-layout__content min-w-0 min-h-dvh bg-surface"
      :class="isStandalone ? 'block p-0' : 'grid content-center px-4 py-12 sm:px-6 lg:px-24'"
    >
      <div
        class="auth-layout__content-inner"
        :class="
          isStandalone
            ? 'm-0 w-full transform-none'
            : 'mx-auto mb-5 w-96 max-lg:w-[min(100%,24rem)]'
        "
      >
        <AuthBrandLogo v-if="showLogo" class="auth-layout__logo mb-6 h-10" />
        <slot />
      </div>
      <footer
        v-if="$slots.footer"
        class="auth-layout__footer mx-auto mt-md w-[min(100%,28rem)] text-center text-muted"
      >
        <slot name="footer" />
      </footer>
    </section>
    <AuthBrandPanel v-if="!isStandalone" class="auth-layout__brand max-lg:hidden" />
  </main>
</template>
